module.exports = __webpack_public_path__ + "img/home.7f173276.svg";